import { useMemo } from 'react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import map from 'lodash/map';
import SpeechBubble from '../atoms/SpeechBubble';
import Text from '../atoms/Text';
import AutofitText from './AutofitText';
import { getMapPosition } from './MapPosition';
import type { Round } from '../../store/PlaythroughSlice';
import { findReaction } from '../../data/Personas';
import type { Persona } from '../../data/Personas';
import { hasScore } from '../../data/Score';

export interface StateProps {
	personas: Persona[];
	lastFinishedRound?: Round;
}

export interface DispatchProps {}

export interface OwnProps {
	animationDelay?: number;
}

type Props = StateProps & DispatchProps & OwnProps;

const PersonasFeedbackMapLayer: FunctionComponent<Props> = (props: Props) => {
	const { animationDelay = 4, personas, lastFinishedRound } = props;
	const { t } = useTranslation();

	const bubbleComponents = useMemo(
		() =>
			map(personas, (persona, index) => {
				if (lastFinishedRound?.concept && lastFinishedRound.personaScores) {
					if (hasScore(lastFinishedRound.personaScores, persona.name)) {
						const position = getMapPosition(index);
						return (
							<SpeechBubble
								key={`feedback_${index}_${persona.name}`}
								anchor="left_top"
								width="11.5vw"
								height="13vh"
								position="absolute"
								left={`calc(${position.x} + 3vmin)`}
								top={position.y}
								fadeInDelay={animationDelay * 1_000 + 200 * index}
								fadeInDuration={300}
							>
								<AutofitText>
									<Text
										content={t(
											findReaction(persona, lastFinishedRound.concept)
												?.reaction ?? ''
										)}
									/>
								</AutofitText>
							</SpeechBubble>
						);
					}
				}
				return undefined;
			}),
		[t, animationDelay, personas, lastFinishedRound]
	);

	return <>{bubbleComponents}</>;
};

export default PersonasFeedbackMapLayer;
